import { render, staticRenderFns } from "./HistoryTokenList.vue?vue&type=template&id=1381f7a8&scoped=true"
import script from "./HistoryTokenList.vue?vue&type=script&lang=js"
export * from "./HistoryTokenList.vue?vue&type=script&lang=js"
import style0 from "./HistoryTokenList.vue?vue&type=style&index=0&id=1381f7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1381f7a8",
  null
  
)

export default component.exports